// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__y08Bj","opened":"style_opened__sujVO","modal":"style_modal__Pm3cF","close":"style_close__D9oft","cmodal":"style_cmodal__botSQ"};